import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'closingReports/'

const initialState = {
    cd: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getClosingReport = createAsyncThunk('cr/gcr', async (closingDate, thunkAPI) => {
    try {
        console.log('Closing Date', closingDate)
        const result = await axios.post(API_URL + 'getClosingReport', closingDate)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const ClosingReportSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.cd = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getClosingReport.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getClosingReport.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.cd = action.payload
            })
            .addCase(getClosingReport.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = ClosingReportSlice.actions

export default ClosingReportSlice.reducer